import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-patient-ids',
    templateUrl: './patient-ids.component.html',
    styleUrls: ['./patient-ids.component.scss'],
    standalone: false
})
export class PatientIdsComponent implements OnInit, OnChanges {
  @Input() patientIDs: any[] = [];
  @Input() currentFacility: string = '';
  @Input() resetToken: number = 0;
  @Output() selectedPatientIdEvent: EventEmitter<any> = new EventEmitter<any>();

  selectedPatientId: any = null;
  currentFacilityPatientId: any = null;
  otherPatientIDs: any[] = [];
  showOtherPatientIds = true; // Show by default, or true only if there's 1 other ID

  constructor() {}

  ngOnInit(): void {
    this.initializePatientIds();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['patientIDs'] || changes['currentFacility']) {
      this.initializePatientIds();
    }
    if (changes['resetToken'] && !changes['resetToken'].firstChange) {
      this.selectedPatientId = null;
      this.showOtherPatientIds = this.otherPatientIDs.length === 1;
    }
  }

  /**
   * Initialize patient IDs by separating current facility ID from others
   */
  private initializePatientIds(): void {
    if (!this.patientIDs || this.patientIDs.length === 0) {
      this.currentFacilityPatientId = null;
      this.otherPatientIDs = [];
      return;
    }

    // Find current facility patient ID
    this.currentFacilityPatientId = this.patientIDs.find(id => 
      this.isCurrentFacilityPatientId(id)
    ) || null;

    // Get all other patient IDs (excluding current facility)
    this.otherPatientIDs = this.patientIDs.filter(id => 
      !this.isCurrentFacilityPatientId(id)
    );

    // If there's only 1 other patient ID, show it by default
    // If there are more than 1, hide them initially
    this.showOtherPatientIds = this.otherPatientIDs.length === 1;
  }

  /**
   * Check if a patient ID belongs to the current facility
   * @param patientId - The patient ID object with facility and value properties
   * @returns true if the patient ID matches the current facility
   */
  isCurrentFacilityPatientId(patientId: any): boolean {
    if (!this.currentFacility || !patientId?.facility) {
      return false;
    }
    return patientId.facility === this.currentFacility;
  }

  /**
   * Select a patient ID from the other patient IDs list
   * @param patientId - The patient ID to select
   */
  selectPatientId(patientId: any): void {
    // Don't allow selecting current facility patient ID
    if (this.isCurrentFacilityPatientId(patientId)) {
      return;
    }
    this.selectedPatientId = patientId;
    this.showOtherPatientIds = false;
    this.selectedPatientIdEvent.emit(patientId);
  }

  /**
   * Toggle showing/hiding other patient IDs
   */
  toggleOtherPatientIds(): void {
    this.showOtherPatientIds = !this.showOtherPatientIds;
  }

  /**
   * Track by function for patient IDs
   * @param index - The index of the item
   * @param item - The patient ID item
   * @returns A unique identifier for the item
   */
  trackByPatientId(index: number, item: any): string {
    return item.facility + '_' + item.value;
  }
}
